import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successEditProfile = username => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в профиль сотрудника «${username}»`,
});

export const successCreateProfile = (role) => ({
  ...optionsDefault,
  title: 'Сотрудник успешно добавлен!',
  content: `Сотрудник успешно добавлен в должности «${role}»`,
});

export const successUpdateStatus = (username, status) => {
  switch (status) {
    case 'revoke':
      return {
        ...optionsDefault,
        title: `Запрос отклонен!`,
        content: `Запрос на сотрудничество с водителем «${username}» отклонен.`,
      };
    case 'archive':
      return {
        ...optionsDefault,
        title: `Сотрудник успешно архивирован!`,
        content: `Сотрудник «${username}» успешно архивирован. Вход в систему для него заблокирован.`,
      };
    case 'active':
      return {
        ...optionsDefault,
        title: `Сотрудник успешно восстановлен!`,
        content: `Сотрудник «${username}» успешно восстановлен. Вход в систему для него снова доступен.`,
      };
    default:
      return {
        ...optionsDefault,
        title: `Статус успешно изменен!`,
        content: `Статус сотрудника успешно изменен!`,
      };
  }
};

export const successOfferCreation = number => ({
  ...optionsDefault,
  title: `Предложение успешно сохранено!`,
  content: `Предложение «${number}» сохранено и перемещено в раздел «Предложения»`,
});

export const successUpdateOffer = (number, name) => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в предложение «${number}» ${(name &&
    '(' + name + ')') ||
    ''}!`,
});
